export default "__VITE_ASSET__7e735a96__"